import { useContext } from 'react';

import { CatalogActionContext, CatalogValueContext } from './context';

const useCatalogValue = () => {
  const context = useContext(CatalogValueContext);
  if (!context) {
    throw new Error(
      'useCatalogValue must be used within a <CatalogFormContext />',
    );
  }
  return context;
};

const useCatalogAction = () => {
  const context = useContext(CatalogActionContext);
  if (!context) {
    throw new Error(
      'useCatalogAction must be used within a <CatalogFormContext />',
    );
  }
  return context;
};

export { useCatalogAction, useCatalogValue };
